import { render, staticRenderFns } from "./TprPro.vue?vue&type=template&id=3f870c91&scoped=true"
import script from "./TprPro.vue?vue&type=script&lang=js"
export * from "./TprPro.vue?vue&type=script&lang=js"
import style0 from "./TprPro.vue?vue&type=style&index=0&id=3f870c91&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f870c91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3942211627/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f870c91')) {
      api.createRecord('3f870c91', component.options)
    } else {
      api.reload('3f870c91', component.options)
    }
    module.hot.accept("./TprPro.vue?vue&type=template&id=3f870c91&scoped=true", function () {
      api.rerender('3f870c91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TprPro.vue"
export default component.exports